export default {
  strict: true,
  namespaced: true,
  state: {
    location: {
      list: [],
      selected: null,
      loading: false
    },
    date: {
      show: false,
      start: null,
      end: null
    },
    list: [],
    sort: 'lowToHigh',
    categories: [],
    filter: {
      categories: []
    },
    view: null,
    trips: {
      details: '',
      list: [],
      show: false,
      selected: ''
    },
    block: '',
    commit: ''
  },
  mutations: {
    setData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setLocationData (state, data) {
      for (let field in data) {
        state.location[field] = data[field]
      }
    },
    setDateData (state, data) {
      for (let field in data) {
        state.date[field] = data[field]
      }
    },
    setFilterData (state, data) {
      for (let field in data) {
        state.filter[field] = data[field]
      }
    },
    toggleFilterCategory (state, value) {
      let i = state.filter.categories.indexOf(value)
      if (i > -1) state.filter.categories.splice(i, 1)
      else state.filter.categories.push(value)
    },
    setTripsData (state, data) {
      for (let field in data) {
        state.trips[field] = data[field]
      }
    },
    setBlockData (state, data) {
      for (let field in data) {
        state.block[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sight-seeing/index.js